module.exports = __webpack_public_path__ + "img/stage-7.7df38ad7.png";